import { Lock } from '@styled-icons/material';

import createStyledIcon from './createStyledIcon';

export default createStyledIcon(Lock);
